import { render, staticRenderFns } from "./BrandSearch.vue?vue&type=template&id=3ffef7db&scoped=true"
import script from "./BrandSearch.vue?vue&type=script&lang=js"
export * from "./BrandSearch.vue?vue&type=script&lang=js"
import style0 from "./BrandSearch.vue?vue&type=style&index=0&id=3ffef7db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffef7db",
  null
  
)

export default component.exports